const blog = {
    title: 'Blog',
    seeAll: 'See all',
}

export default blog
